import { getCurrentWebUserIdToken } from "./firebaseWeb";

const LIVE_ACTION_ENDPOINT = "/api/live-action";

export async function getLiveActionResource(resource, params = {}) {
  const search = new URLSearchParams({ resource });
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, value);
  });
  const response = await fetch(`${LIVE_ACTION_ENDPOINT}?${search.toString()}`, {
    headers: { Accept: "application/json" },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) throw new Error(data.message || "Canlı veri alınamadı.");
  return data.data;
}

export async function postLiveAction(action, payload = {}) {
  const token = await getCurrentWebUserIdToken(true);
  if (!token) throw new Error("Bu işlem için giriş yapmalısın.");
  const response = await fetch(LIVE_ACTION_ENDPOINT, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ action, ...payload }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) throw new Error(data.message || "Canlı işlem tamamlanamadı.");
  return data;
}
